import * as yup from 'yup';
export var emailValidation = yup.string().email().required().max(100);